import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './pages/HomePage';
import PokemonDetailPage from './pages/PokemonDetailPage';
import TypePage from './pages/TypePage';
import ComparePage from './pages/ComparePage';
import SearchPage from './pages/SearchPage';
import TopRankingsPage from './pages/TopRankingsPage';
import AllPokemonPage from './pages/AllPokemonPage';
import AllTypesPage from './pages/AllTypesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SitemapPage from './pages/SitemapPage';
import RobotsPage from './pages/RobotsPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <ScrollToTop />
        <Header />
        <main className="flex-1" role="main">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/pokemon/:name" element={<PokemonDetailPage />} />
              <Route path="/pokemon" element={<AllPokemonPage />} />
              <Route path="/type/:type" element={<TypePage />} />
              <Route path="/types" element={<AllTypesPage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/top/:type" element={<TopRankingsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/sitemap.xml" element={<SitemapPage />} />
              <Route path="/robots.txt" element={<RobotsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;